import { render, staticRenderFns } from "./LabelComparisons.vue?vue&type=template&id=dbe4b292"
import script from "./LabelComparisons.vue?vue&type=script&lang=js"
export * from "./LabelComparisons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports